import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FieldWriteComponent } from '../field-write.component';
import { FormBuilder } from '@angular/forms';
import { Animations } from './../../../Animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-basic-field-w',
  templateUrl: './basic-field-w.component.html',
  styleUrls: ['./../Field-Styles.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class BasicFieldWComponent extends FieldWriteComponent implements OnInit {
  constructor(fb: FormBuilder, trans: TranslateService) {
    super(fb, trans);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  checkAndCollectErrors(setError: boolean = true) { // overrides og func and adds extra errors if needed...
    super.checkAndCollectErrors(setError);
  }
}
